import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';


@Component({
	selector: 'app-header-doc',
	templateUrl: './header-doc.component.html',
	styleUrls: ['./header-doc.component.scss']
})
export class HeaderDocComponent implements OnInit {
	utils: any;
	highlighted: boolean = false;
	codeHtml: string;
	codeJs: string;
	infoComponent: { titulo: string; descripcion: string };
	constructor(private highlightService: HighlightService) 
	{
		this.utils = window.utils;
		this.codeHtml = `
		<nav class="navbar navbar-expand-lg fixed-top navbar-govco navbar-expanded">
			<div class="navbar-container container">
				<div class="navbar-logo float-left">
					<a class="navbar-brand" href="utils.getServerWebUrl()+'/'">
					<img src="https://cdn.www.gov.co/assets/images/logo.png" height="30" alt="Logo Gov.co" />
					</a>
					<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapsible" aria-controls="navbarCollapsible" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
					</button>
				</div>
				<div class="collapse navbar-collapse navbar-first-menu float-right">
					<div class="nav-primary mx-auto">
						<ul class="navbar-nav ml-auto nav-items nav-items-desktop">
						</ul>
					</div>
					<div class="nav-item-primary ml-auto mr-2">
						<div class="form-inline form-search-bar my-2 my-lg-0 search-desktop-container">
							<input class="form-control mr-sm-2 search-navbar search-desktop-searchTerm searchTerm"
							type="search"
							placeholder="Buscar "
							aria-label="Search"
							name="searchTerm"
							id="search-desktop"
							/>
							<span class="govco-icon govco-icon-search-cn icon-search notranslate" (click)="btnSearchGovCo()"></span>
						</div>
						<span class="govco-icon govco-icon-language-en-n lang-govco ml-3" (click)="changeLang()"></span>
					</div>
				</div>
			</div> 
			<div class='nav-secondary show-transition' id="nav-secondary">
			<div class="container">
				<div class="collapse navbar-collapse navbar-first-menu">
					<ul class="navbar-nav w-100 d-flex nav-items nav-items-desktop">
						<li class="nav-item ">
							<a href="/ficha-tramites-y-servicios/" class="nav-link">Trámites y servicios</a>
						</li>
						<li class="nav-item ">
							<a href="/tu-opinion-cuenta/" class="nav-link">Tu Opinión Cuenta</a>
						</li>
						<li class="nav-item ">
							<a href="/entidades/" class="nav-link">Entidades</a>
						</li>
					</ul>
				</div>
			</div>
			</div>
			<div class="navbar-nav navbar-notifications" id="notificationHeader"></div>
	  	</nav>
		`;

		this.infoComponent = {
			titulo: 'Header',
			descripcion:
				'El componente Header, hace parte de los componentes maestros este componente debe contener siempre el el logo de GOV.CO.'
		};
	}

	ngAfterViewChecked() {
		if (!this.highlighted) {
			this.highlightService.highlightAll();
			this.highlighted = true;
		}
	}

	ngOnInit() {
		this.utils.init();
	}
}
